import { mapActions, mapGetters } from 'vuex';
import UserTagSelect from '../../components/posts/UserTagSelect.vue';
import { getOwnerId } from '../getOwnerId';


export default {
  components: {
    UserTagSelect,
  },
  data() {
    return {
      showVideo: true,
      video: '',
      images: [],
      postMedia: [],
      content: null,
      videoUrl: '',
      isVideoUrlValid: false,
      isOpenTag: false,
      tagIndex: null,
      text: '',
      items: [],
      addInCompanyWall: false,
      tagedUsers: {},
      resetUploaders: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
  },
  methods: {
    checkUrlVideoValidation(value) {
      this.isVideoUrlValid = value;
    },
    tagUser(simbol) {
      this.tagIndex = simbol.srcElement.selectionEnd;
    },
    ...mapActions({
      addPost: 'posts/addPost',
      getUserWall: 'posts/getUserWall',
    }),
    async formSubmit() {
      const isValid = await this.$validator.validate();
      const { customerId } = this.$route.params;
      const data = {
        user: this.userInfo.url,
        content: this.content || null,
        post_media: [],
      };
      if (this.images.length || this.videoUrl) {
        if (this.images.length) {
          this.images.forEach((image) => {
            data.post_media.push(
              {
                media_type: 'image',
                image_field: image,
              },
            );
          });
        } else {
          data.post_media.push(
            {
              media_type: 'video',
              video_field: this.videoUrl,
            },
          );
        }
      }
      const isVideoUrlValid = !(this.videoUrl.length && !this.isVideoUrlValid);
      if (isValid && isVideoUrlValid) {
        if (Object.keys(this.tagedUsers).length > 0) {
          const taggedCustomers = [];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of Object.entries(this.tagedUsers)) {
            if (this.content.includes(key)) {
              taggedCustomers.push(value);
            }
          }
          data.tagged_customers = taggedCustomers;
          const taggedPersons = data.tagged_customers.map(({ customer_id }) => customer_id);
          data.tagged_persons = taggedPersons;
        }
        if (this.addInCompanyWall) {
          data.company = this.userInfo.company;
        } else {
          data.company = null;
        }
        if (this.content || this.images.length || this.videoUrl) {
          await this.addPost({ data, customerId }).then(async () => {
            await this.getUserWall({ page: 1, customerId: getOwnerId() });
            this.addInCompanyWall = false;
            this.$notify({
              group: 'userAlerts',
              title: 'Success',
              text: 'The post successfully created!',
              type: 'success',
            });
          });
        } else {
          this.$notify({
            group: 'userAlerts',
            title: 'Warning',
            text: 'Please add something to post!',
            type: 'warn',
          });
        }
        this.images = [];
        this.video = '';
        this.content = '';
        this.tagedUsers = {};
        this.postMedia = [];
        this.videoUrl = '';
        this.$validator.reset();
        this.resetUploaders = true;
      }
    },
    addPostTag(data) {
      this.content = `${this.content.slice(0, this.tagIndex + 1)}${data.full_name} ${this.content.slice(this.tagIndex + 1)}`;
      this.tagedUsers[`${data.full_name}`] = data;
    },
  },
  watch: {
    images() {
      if (this.images.length) this.showVideo = false;
      else this.showVideo = true;
    },
    content(val) {
      if (val === '@'
        || val.slice(this.tagIndex - 1, this.tagIndex + 1) === ' @'
        || val.slice(this.tagIndex - 1, this.tagIndex + 1) === '\n@') {
        this.isOpenTag = true;
      }
    },
  },
};
